import styled, { css } from 'styled-components'

export const Container = styled.div`
hr{
    height: 1.25rem;
    width: .25rem;
    background: #${props => props.theme};
    border: none;
    margin-left: 1.8rem;
}
`

export const Content = styled.div`
display: flex;
align-items: center;
`

export const Card = styled.div<{disabled: boolean}>`
    display: flex;
    align-items: center;
    color: white;
    cursor: pointer;
    border-radius:.75rem;
    min-height: 64px;
    padding-left: 2rem;
    padding-right: 2rem;
    background: #${props => props.theme};
    box-shadow: var(--SombraBackground);

    svg{
        margin-left: 1rem;
    }

    &:hover{
        box-shadow: var(--SombraBtns);
        filter: brightness(.9);
    }

    ${props => props.disabled && css`
        opacity: 50%;
        pointer-events: none;
    `
  }
`

export const Circle = styled.div`
border:3px solid #${props => props.theme};
box-sizing: border-box;
display: flex;
justify-content:center ;
align-items: center;
font-family: 'Poppins','sans-serif';
text-align: center;
background: var(--c1);
min-height: 4.2rem;
min-width: 4.2rem;
max-height: 4.2rem;
max-width: 4.2rem;
border-radius: 50%;
font-size: 1rem;
font-weight: 800;
`

export const FlexElipse = styled.div`
display: flex;
height: 4.313rem;
align-items: center;
margin-left: .325rem;

div{
    margin-right:.25rem;
}

div:nth-child(1){
    height: 0.5rem;
    width: 0.5rem;
    background: #${props => props.color}40;
    border-radius: 50%;
}

div:nth-child(2){
    height: 0.625rem;
    width: 0.625rem;
    background: #${props => props.color}80;
    border-radius: 50%;
}

div:nth-child(3){
    height: .75rem;
    width: .75rem;
    background:#${props => props.color};
    border-radius: 50%;
    margin-right: .5rem;
}
`
